import "./styles.scss";
import { useIntl } from "react-intl";

export type ITabOptions = "edit" | "history";

export interface ITabsProps {
  activeTab: ITabOptions;
  onTabChange: (tab: ITabOptions) => void;
}

const Tabs = ({ activeTab, onTabChange }: ITabsProps) => {
  const intl = useIntl();

  return (
    <section className="margin-bottom-20 contract-details-tabs-wrap">
      <div className="contract-details-tabs">
        <button
          type="button"
          onClick={() => onTabChange("edit")}
          className={`contract-details-tabs__btn ${activeTab === "edit" ? "contract-details-tabs__btn--active" : ""}`}
        >
          {intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.tabs.edit" })}
        </button>
        <button
          type="button"
          onClick={() => onTabChange("history")}
          className={`contract-details-tabs__btn ${activeTab === "history" ? "contract-details-tabs__btn--active" : ""}`}
        >
          {intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.tabs.history" })}
        </button>
      </div>
    </section>
  )
};

export default Tabs;
